import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import ReactSlider from 'react-slider';
import style from './RangeSlider.module.scss';
export default function RangeSlider(props) {
  const $ = _c(19);
  const {
    min,
    max,
    step,
    value,
    onChange,
    onChangeCommitted,
    disabled
  } = props;
  const [sliderValue, setSliderValue] = useState(value || min);
  let t0;
  let t1;
  if ($[0] !== min || $[1] !== value) {
    t0 = () => {
      setSliderValue(value || min);
    };
    t1 = [min, value];
    $[0] = min;
    $[1] = value;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(_temp3, t2);
  let t3;
  if ($[5] !== max || $[6] !== onChange) {
    t3 = v => {
      const next = Math.min(v, max);
      setSliderValue(next);
      onChange?.(next);
    };
    $[5] = max;
    $[6] = onChange;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== max || $[9] !== onChangeCommitted) {
    t4 = v_0 => onChangeCommitted?.(Math.min(v_0, max));
    $[8] = max;
    $[9] = onChangeCommitted;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== disabled || $[12] !== max || $[13] !== min || $[14] !== sliderValue || $[15] !== step || $[16] !== t3 || $[17] !== t4) {
    t5 = <ReactSlider min={min} max={max} step={step} value={sliderValue} onChange={t3} onAfterChange={t4} disabled={disabled} className={style.slider} thumbClassName={style.slider_thumb} trackClassName={style.slider_track} />;
    $[11] = disabled;
    $[12] = max;
    $[13] = min;
    $[14] = sliderValue;
    $[15] = step;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}
function _temp3() {
  document.querySelectorAll("[class$='-0']").forEach(_temp);
  document.querySelectorAll("[class$='-1']").forEach(_temp2);
}
function _temp2(el_0) {
  el_0.style.background = "#C4C4C4";
}
function _temp(el) {
  el.style.background = "#6a8860";
  el.style.height = "3px";
  el.style.top = "-1px";
}